module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Td3h"))).then(() => parcelRequire('1iHdE'));